import type { MetadataItem } from "@/ui/metadataList";
import type { Predicate } from "../utils";
import { formatPredicate, buildSubtitle, buildExecutionSubtitle } from "../utils";

export function createGithubMetadataItems(
  repositoryName: string | undefined,
  predicates: Predicate[] | undefined,
  pathGlobs?: string[] | undefined,
): MetadataItem[] {
  const metadataItems: MetadataItem[] = [];

  if (repositoryName) {
    metadataItems.push({
      icon: "book",
      label: repositoryName,
    });
  }

  if (predicates && predicates.length > 0) {
    metadataItems.push({
      icon: "funnel",
      label: predicates.map(formatPredicate).join(", "),
    });
  }

  const pathPatterns = pathGlobs?.map((p) => p.trim()).filter(Boolean);
  if (pathPatterns && pathPatterns.length > 0) {
    metadataItems.push({
      icon: "funnel",
      label: pathPatterns.join(", "),
    });
  }

  return metadataItems;
}

export const buildGithubSubtitle = buildSubtitle;
export const buildGithubExecutionSubtitle = buildExecutionSubtitle;
